import { makeApi } from "@zodios/core";
import { z } from "zod";

import { heatPumpBrandDtoSchema } from "@/types/backoffice/dto/heatpump/heatpump-brand-dto.ts";
import { heatpumpCreateBrandDtoSchema } from "@/types/backoffice/dto/heatpump/heatpump-create-brand-dto.ts";
import { heatpumpCreateModelDtoSchema } from "@/types/backoffice/dto/heatpump/heatpump-create-model-dto.ts";
import { heatPumpDeclarationDtoSchema } from "@/types/backoffice/dto/heatpump/heatpump-declaration-dto.ts";
import { heatPumpModelDtoSchema } from "@/types/backoffice/dto/heatpump/heatpump-model-dto.ts";

export const backofficeHeatPumpApi = makeApi([
  {
    method: "get",
    path: "/brand",
    parameters: [
      {
        type: "Query",
        name: "query",
        schema: z.string(),
      },
    ],
    response: z.array(heatPumpBrandDtoSchema),
    alias: "findHeatPumpBrands",
  },
  {
    method: "get",
    path: "/model",
    parameters: [
      {
        type: "Query",
        name: "query",
        schema: z.string(),
      },
      {
        type: "Query",
        name: "brandId",
        schema: z.number(),
      },
    ],
    response: z.array(heatPumpModelDtoSchema),
    alias: "findHeatPumpModels",
  },
  {
    method: "put",
    path: "/site/:siteId",
    parameters: [
      {
        type: "Path",
        name: "siteId",
        schema: z.number(),
      },
      {
        type: "Body",
        name: "body",
        schema: z.array(z.object({ id: z.number() })),
      },
    ],
    response: z.array(heatPumpDeclarationDtoSchema),
    alias: "updateHeatPumpDeclarationInSite",
  },
  {
    method: "post",
    path: "/model",
    parameters: [
      {
        type: "Body",
        name: "body",
        schema: heatpumpCreateModelDtoSchema.required(),
      },
    ],
    response: heatPumpModelDtoSchema,
    alias: "createHeatPumpModel",
  },
  {
    method: "post",
    path: "/brand",
    parameters: [
      {
        type: "Body",
        name: "body",
        schema: heatpumpCreateBrandDtoSchema.required(),
      },
    ],
    response: heatPumpBrandDtoSchema,
    alias: "createHeatPumpBrand",
  },
]);
